import React from 'react';
import Header from '../../header/Header'
import Button from '../../../elements/buttons/Button'
import Heading1 from '../../../elements/titles/Heading1'
import bgHeader from '../../../../medias/images/bg-header-faq.jpg'

function HeaderFaq({ children, img }) {


    return (
        <Header
            img={bgHeader}
            id="headerFaq"
        >
            <div className="flex flex-col items-center">
                <Heading1
                    theme="white"
                    size="medium"
                    classe="relative z-30 text-center"
                >
                    Réponses aux questions les plus posées
                </Heading1>
                <div className="relative z-30">
                    <Button
                        link="/contact"
                        size="big"
                        classe="mt-8 rounded-full z-30 "
                    >
                        Traduire un projet
                    </Button>
                </div>
            </div>
        </Header>
    );
}

export default HeaderFaq;